import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { BrossardProof } from '../components/brossard/BrossardProof';
import { BrossardTransformation } from '../components/brossard/BrossardTransformation';
import { BrossardPromise } from '../components/brossard/BrossardPromise';
import { trackEvent as track } from '../utils/analytics';
export function Brossard() {
  useEffect(() => {
    track('page_view', {
      page: 'brossard'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8274" data-mp="3b7m2v2hdxrso">
      <Header data-id="element-8275" data-mp="3b4zskv340y6r" />
      <main className="pt-[120px]" data-id="element-8276" data-mp="3oy7o2xubadtq">
        <BrossardProof data-id="element-8277" data-mp="3oz96xohkk4m0" />
        <BrossardTransformation data-id="element-8278" data-mp="3oziocnojt3g3" />
        <BrossardPromise data-id="element-8279" data-mp="3k7irj43ryqnq" />
      </main>
      <Footer data-id="element-8280" data-mp="3k6g1szi6uu9e" />
    </div>;
}